<ng-container>
    <button pButton class="p-button-raised p-button-text cbms-row-button" (click)="showScheduleDataDialog()"
            [pTooltip]="isTwin ? 'Show Twin Schedule' : 'Show Schedule'" showDelay="1000" hideDelay="500">
        <mat-icon [svgIcon]="isTwin ? 'twin_schedule' : 'schedule'"></mat-icon>
    </button>
</ng-container>
